(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('application-parameter', {
            parent: 'entity',
            url: '/application-parameter?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.applicationParameter.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/application-parameter/application-parameters.html',
                    controller: 'ApplicationParameterController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('applicationParameter');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('application-parameter-detail', {
            parent: 'entity',
            url: '/application-parameter/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.applicationParameter.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/application-parameter/application-parameter-detail.html',
                    controller: 'ApplicationParameterDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('applicationParameter');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ApplicationParameter', function($stateParams, ApplicationParameter) {
                    return ApplicationParameter.get({id : $stateParams.id});
                }]
            }
        })
        .state('application-parameter.new', {
            parent: 'application-parameter',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/application-parameter/application-parameter-dialog.html',
                    controller: 'ApplicationParameterDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                value: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('application-parameter', null, { reload: true });
                }, function() {
                    $state.go('application-parameter');
                });
            }]
        })
        .state('application-parameter.edit', {
            parent: 'application-parameter',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/application-parameter/application-parameter-dialog.html',
                    controller: 'ApplicationParameterDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ApplicationParameter', function(ApplicationParameter) {
                            return ApplicationParameter.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('application-parameter', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('application-parameter.delete', {
            parent: 'application-parameter',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/application-parameter/application-parameter-delete-dialog.html',
                    controller: 'ApplicationParameterDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ApplicationParameter', function(ApplicationParameter) {
                            return ApplicationParameter.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('application-parameter', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
